import React, { useState } from "react";
import { Text, StyleSheet, View, TouchableOpacity, Platform } from "react-native";

import Icons from "../../common/icons";
import ImageComponent from "../../common/ImageComponent";
import ActivityAssociatedTags from "../TagsList/ActivityAssociatedTags";

export default CopyActivityItem = ({ item, selectActivityTags }) => {
  const [isSelected, setIsSelected] = useState(false);

  const toggleSelectedState = () => {
    selectActivityTags(item, !isSelected);
    setIsSelected(!isSelected);
  };

  return (
    <View style={styles.container}>
      <View style={[styles.listItem, isSelected && styles.listItemExpanded]}>
        <ImageComponent styles={styles.activityLogo} icon={item.icon} />
        <TouchableOpacity style={{ flex: 1 }} onPress={toggleSelectedState}>
          <Text
            style={[styles.itemName, isSelected && styles.itemNameExpanded]}
          >
            {item.name}
          </Text>
        </TouchableOpacity>
        <Icons.ArrowDown styles={styles.arrowRight} isCollapsed={!isSelected} />
      </View>

      <ActivityAssociatedTags tags={item.tagsList} isCollapsed={!isSelected} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 14,
    paddingTop: 15,
    paddingLeft: 30,
    marginBottom: 6,
  },
  listItemExpanded: {
    backgroundColor: "#ebf9f3",
  },

  itemName: {
    color: "#333333",
    lineHeight: 14,
    letterSpacing: 1,
    fontSize: 12,
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
    paddingLeft: 20,
  },
  itemNameExpanded: {
    color: "#000",
    fontWeight: "bold",
  },
  activityLogo: {
    width: 20,
    height: 20,
  },
  arrowRight: {
    marginRight: 30,
  },
});
